import React, { FC } from 'react';
import { CustomDatagridToolbarProps } from './CustomDatagridToolbarProps';
import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-premium';
import SaveColumnsButton from '../SaveColumnsButton';
import ResetDefaultColumnsButton from '../ResetDefaultColumnsButton';
import skapaColours from '@ingka/variables/colours-css';

const CustomDatagridToolbar: FC<CustomDatagridToolbarProps> = ({
  handleStorage,
  columnsButton,
  filterButton,
  exportButton,
  handleReset,
}) => {
  const styleForButton = {
    color: skapaColours.colourInteractivePrimaryBgDefault,
  };

  return (
    <GridToolbarContainer>
      {columnsButton && (
        <GridToolbarColumnsButton
          slotProps={{ button: { style: styleForButton } }}
        />
      )}
      {columnsButton && (
        <>
          <SaveColumnsButton
            style={styleForButton}
            handleStorage={handleStorage}
          />
          {handleReset && (
            <ResetDefaultColumnsButton
              style={styleForButton}
              handleReset={handleReset}
            />
          )}
        </>
      )}
      {filterButton && (
        <GridToolbarFilterButton
          slotProps={{ button: { style: styleForButton } }}
        />
      )}
      {exportButton && <GridToolbarExport style={styleForButton} />}
    </GridToolbarContainer>
  );
};

export default CustomDatagridToolbar;
